import { gql } from '@/__generated__';

export const DGA_REPORTS_TABLE_GET_DEVICE = gql(`#graphql
  query DGAReportsTableModal_GetReports(
    $deviceId: ID!,
    $reportsInput: DGAReportsInput,
    $reportsPagination: DynamoPaginationInput

  ) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        name
      }
      dga {
        id
        configuration {
          id
          type
          frequency
        }
        reports(input: $reportsInput, pagination: $reportsPagination) {
          items {
            data {
              flow
              accumulatedVolume
              level
            }
            timestamp
            executionTimestamp
            message
            confirmationId
            status
          }
          pageInfo {
            count
            lastEvaluatedKey
          }
        }
      }
    }
  }
`);
